<template>
  <div>
    <navigation></navigation>

    <div class="container px-4 mx-auto">
      <h1 class="mb-3">Forgot Password</h1>
      <form
        class="mb-10"
        data-cy="forgot-password-reset-form"
        v-if="!user"
        v-on:submit.prevent="getResetLink"
      >
        <div class="mb-3">
          <label
            class="font-semibold text-gray-700 block mb-1"
            for="email-input"
            >Email</label
          >
          <input
            class="border border-gray rounded p-2"
            data-cy="email-input"
            id="email-input"
            placeholder="Email"
            type="text"
            v-model="email"
          />
        </div>
        <div class="mb-3">
          <label
            class="font-semibold text-gray-700 block mb-1"
            for="password-input"
            >New Password</label
          >
          <input
            class="border border-gray rounded p-2"
            data-cy="password-input"
            id="password-input"
            type="password"
            v-model="password"
          />
        </div>
        <div class="mb-3">
          <label
            class="font-semibold text-gray-700 block mb-1"
            for="password-confirm-input"
            >Confirm New Password</label
          >
          <input
            class="border border-gray rounded p-2"
            data-cy="password-confirm-input"
            id="password-confirm-input"
            type="password"
            v-model="passwordConfirm"
          />
        </div>
        <input
          class="px-4 py-2 bg-blue text-white rounded cursor-pointer"
          type="submit"
          value="Submit"
        />
      </form>
      <div v-else>
        Oops. It looks like you're already logged in.
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { API_URL } from "../env";
import Navigation from "./Navigation.vue";

export default {
  name: "forgot-password-reset",
  data() {
    return {
      email: "",
      password: "",
      passwordConfirm: ""
    };
  },
  components: {
    Navigation
  },
  methods: {
    async getResetLink() {
      try {
        if (!this.validate()) {
          this.flashMessage.error({
            message: "There was an error. Please check the form."
          });
          return;
        }
        this.$loading(true);
        const data = {
          email: this.email,
          password: this.password,
          password_confirm: this.passwordConfirm
        };
        const res = await this.axios.post(
          `${API_URL}/reset-forgot-password`,
          data
        );
        this.$loading(false);
        this.clearForm();
        this.flashMessage.success({
          message:
            "Your password was successfully reset. You may now login with your new password."
        });
      } catch (error) {
        this.flashMessage.error({ message: error.response.data.message });
        this.$loading(false);
      }
    },
    validate() {
      const passwordsMatch = this.password === this.passwordConfirm;
      const emailNotBlank = this.email !== "";
      return emailNotBlank && passwordsMatch;
    },
    clearForm() {
      this.email = "";
      this.password = "";
      this.passwordConfirm = "";
    }
  },
  computed: {
    user() {
      return this.$store.state.notes.user;
    }
  }
};
</script>
